import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-question-test-dialog',
  templateUrl: './question-test-dialog.component.html',
  styleUrls: ['./question-test-dialog.component.scss']
})
export class QuestionTestDialogComponent implements OnInit {

  formQuestion: FormGroup;
  questions: Array<any> = [];
  submiting: boolean = false;

  public get Options(): FormArray {
    return this.formQuestion.get('options') as FormArray;
  }

  constructor(
    private fb: FormBuilder,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<QuestionTestDialogComponent>,
    private http: HttpService,
    private errorReport: ErrorReportService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formQuestion = fb.group({
      id: [null],
      descriptionQuestion: [null, [Validators.required, Validators.maxLength(256)]],
      questionType: [null, Validators.required],
      required: [true, Validators.required],
      options: fb.array([]),
      testId: data.testId
    });
    this.addOptions();

    if (data.question) {

      const { descriptionQuestion, questionType, id, required, options } = data.question;
      // console.log('DATA', data.question)
      this.formQuestion.patchValue({
        id,
        descriptionQuestion,
        questionType,
        required: required == '1',
      })

      this.Options.clear();

      options.forEach(option => {
        option.isRight = option.isRight == '1';
        this.addOptions(option.name, option.isRight);
      });

    }

  }

  ngOnInit(): void {

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger, scope } = result;
        if (scope.indexOf('selection_test_question') > -1)
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)

    this.formQuestion.get('questionType')
      .valueChanges
      .subscribe(
        questionType => {

          const id = this.formQuestion.get('id').value;

          if (id === null) {

            this.Options.clear();
            if (questionType !== 'dissertative')
              this.addOptions();

          }

        }
      )

  }

  addOptions(name = null, isRight = false) {
    const controls = this.formQuestion.get('options') as FormArray;
    controls.push(this.fb.group({
      name: [name, Validators.required],
      isRight: [isRight, Validators.required]
    }));
  }

  removeOption(i: number) {

    if (!confirm('Deseja realmente remover essa opção?'))
      return;

    this.Options.removeAt(i);

  }

  isFormValid(): boolean {
    const questionType = this.formQuestion.get('questionType').value;
    if (questionType === 'dissertative') {
      return true; // Sempre válido para perguntas dissertativas
    }
    return this.Options.length > 0; // Para outros tipos, verifica se há opções
  }

  numQuestion = 0;

  submitQuestion() {
    const isValid = !this.formQuestion.invalid;

    if (isValid) {
      const data = this.formQuestion.getRawValue();
      const options = data.options;
      // Filtra as opções com isRight igual a true
      const rightOptions = options.filter(option => option.isRight);

      if (data.questionType == 'multiple') {

        if (rightOptions.length == 0) {
          this.snackbar.open('Por Favor antes de salvar escolha uma opção como correta', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        } else if (rightOptions.length > 1) {
          this.snackbar.open('Por Favor selecione apenas uma opção como correta antes de salvar', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        }

      }

      if (data.questionType == 'option') {
        if (rightOptions.length == 0) {
          this.snackbar.open('Por Favor antes de salvar escolha uma opção como correta', 'OK', { duration: 8000, panelClass: ['error-snackbar'] });
          return false;
        }
      }

      const existingQuestionIndex = this.questions.findIndex(q => q.id === data.id);

      // if (existingQuestionIndex !== -1) {
      //   // Se a pergunta já existir, atualize-a
      //   this.questions[existingQuestionIndex] = data;
      // } else {
      //   // Caso contrário, adicione como uma nova pergunta
      //   data.id = this.numQuestion++;
      //   this.questions.push(data);
      // }

      let request$: Observable<any>;

      // console.log('DATA 2', data)
      //request$ = data.id ? this.http.save('selection_test_question:update', data) : this.http.save('selection_test_question', data);
      
      if (data.id) {
        request$ = this.http.save('selection_question_test:update', data);
      } else {
        this.dialogRef.close(data); // Passa os dados para o componente pai
      }

      if (request$) {
        request$.subscribe(
          (result: any) => {
            this.dialogRef.close(data);
          },
          (err: any) => this.errorReport.showMessage(err)
        );
      }

    }
  }

}
